"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AriForm = exports.Builders = exports.FormBuilder = void 0;
const FormBuilder_1 = __importDefault(require("./FormBuilder"));
exports.FormBuilder = FormBuilder_1.default;
const Builders_1 = __importDefault(require("./builders/Builders"));
exports.Builders = Builders_1.default;
const ariform_form_1 = require("./ariform.form");
Object.defineProperty(exports, "AriForm", { enumerable: true, get: function () { return ariform_form_1.AriForm; } });
ariform_form_1.AriForm.Builders = Builders_1.default;
ariform_form_1.AriForm.isBuilder = true;
ariform_form_1.AriForm.use = (0, ariform_form_1.useModule)((key, mod) => {
    if (key === 'builders') {
        ariform_form_1.AriForm.Builders.addBuilders(mod.builders);
        return true;
    }
    return false;
});
__exportStar(require("./ariform.form"), exports);
